import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { useParams } from "react-router";
import { editorProjectServices } from "../../../APIServices/Editor/editorProjectServices";

const AddNewFileFolder = ({ Show, Hide, Title, getEditorProjectData, type, projectData }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [name, setName] = useState("");
  const { studyId } = useParams()

  const addNewEditorProjectFileFolder = async () => {
    setButtonLoader(true)
    let userData = {};
    userData.studyId = studyId;
    userData.projectId = projectData?.projectId;
    userData.parentId = projectData?.uniqueId;
    userData.path = projectData?.path;
    userData.name = name;
    userData.type = type;
    let data = await editorProjectServices.addNewEditorProjectFileFolder(
      userData
    );
    setButtonLoader(false)
    if (data?.statusCode === 200) {
      getEditorProjectData();
      setName("")
      Hide()
    }
  };

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              {type === "file" ? "File" : "Folder"} Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              onChange={(e) => setName(e.target.value)}
              value={name}
              className="fontSize12"
              placeholder={`Enter ${type === "file" ? "File" : "Folder"} Name`}
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            onClick={addNewEditorProjectFileFolder}
            disabled={buttonLoader || !name}
            title={Title}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Adding...
              </div>
            ) : (
              Title
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default AddNewFileFolder;